module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-container', [_c('v-alert', {
    attrs: {
      "color": "error",
      "icon": "cloud_off",
      "value": !_vm.online,
      "transition": "scale-transition"
    }
  }, [_vm._v("\n      No Connection, using saved data.\n    ")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "info",
      "value": !_vm.hasCustomers && !_vm.loading,
      "icon": "info_outline"
    }
  }, [_vm._v("\n      You have not been granted access to any customers yet\n    ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center"
  }, [(_vm.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7,
      "color": "primary"
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.jobs), function(job, i) {
    return _c('v-list', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple"
      }],
      key: i,
      staticClass: "mb-2 pa-2",
      attrs: {
        "dark": "",
        "two-line": ""
      }
    }, [_c('v-list-tile', {
      attrs: {
        "to": '/JobList/' + job.customer + '/' + job.number
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Customer: " + _vm._s(job.customer))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Number: " + _vm._s(job.number))])], 1)], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b7bf7ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomerList.vue
// module id = 675
// module chunks = 1